module.exports = __webpack_public_path__ + "static/locations-background-b7c07b9a6ede99e5bf982a9a41d3b2fd.jpg";